const ACTION_SUBJECT_TAG = '[Authentication]';

export class RegisterAuthState {
  static readonly type = `${ACTION_SUBJECT_TAG} Update pending auth state`;

  constructor(
    public message: string,
    public authenticated: boolean,
    public inProgress: boolean,
    public status: string,
    public qrCodeData: string
  ) {}

  public static empty(): RegisterAuthState {
    return new RegisterAuthState(null, null, null, null, null);
  }
}
